
import { mdiPlus } from '@mdi/js'
export default {
  name: 'FilterFlyout',
  components: {},
  data () {
    return {
      mdiPlus
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.catalog.filterDrawer
      },
      set (value) {
        this.$store.commit('catalog/setFilterDrawer', value)
      }
    }
  }

}
